export enum EOrderFillEnums {
  REQUESTED = 'requested',
  ACCEPTED = 'accepted',
  FILLED = 'filled',
  ACCEPTED_NOT_FILLED = 'acceptedNotFilled',
  NOT_ACCEPTED = 'notAccepted'
}

export enum EOrderFillDateInterval {
  LAST_WEEK = 'Last Week',
  LAST_WEEKS = 'Last 4 Weeks',
  LAST_MONTH = 'Last Calendar Month',
  YEAR_TO_DATE = 'YTD',
  LAST_YEAR = 'Last Year',
  CUSTOM = 'Custom Date Range'
}

export enum EOrderFillDateType {
  LAST_WEEK = 'LAST_WEEK',
  LAST_WEEKS = 'LAST_4_WEEKS',
  LAST_MONTH = 'LAST_CALENDAR_MONTH',
  YEAR_TO_DATE = 'YEAR_TO_DATE',
  LAST_YEAR = 'LAST_YEAR',
  CUSTOM = 'CUSTOM'
}

export enum EOrderViewType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}

export enum EOrderBarChartTitle {
  DAILY = 'Daily Totals',
  WEEKLY = 'Weekly Totals',
  MONTHLY = 'Monthly Totals'
}

export enum EOrderPieChartTitle {
  DAILY = 'Weekly Totals',
  WEEKLY = 'Monthly Totals',
  MONTHLY =  'Yearly Totals'
}
